import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import TopBar from "./TopBar";
import { Link } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import { useEffect } from "react";
import CustomSnackbar from "../shared/snackbar.js";
import axios from "axios";
import TermsConditionVector from "../../assets/images/termsandconditionvector.png";

function Confirmation({ ldapIntegration, mappingVmToDb }) {
  const styles = {
    typography: {
      "@media (max-width: 600px)": {
        fontSize: "32px", // Adjust the font size for smaller screens
        textAlign: "center",
      },
    },
    // Other styles...
  };
  const MainHeading = {
    typography: {
      "@media (max-width: 600px)": {
        fontSize: "24px", // Adjust the font size for smaller screens
        textAlign: "center",
      },
    },
    // Other styles...
  };
  const smallContent = {
    typography: {
      "@media (max-width: 600px)": {
        fontSize: "18px", // Adjust the font size for smaller screens
        textAlign: "center",
      },
    },
    // Other styles...
  };
  const otherStyles = {
    typography: {
      "@media (max-width: 600px)": {
        fontSize: "18px", // Adjust the font size for smaller screens
      },
    },
    // Other styles...
  };
  const description = {
    typography: {
      "@media (max-width: 600px)": {
        fontSize: "16px",
        textAlign: "center",
      },
    },
  };
  const [open, setAppOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [variant, setMessageVariant] = React.useState("");
  const [snackbaropen, setSnackbarOpen] = React.useState(false);
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;
  const CREATE_VM = `${SERVER_URI}/user/createVirtualMachine`;
  const PAYMENT_VALIDATE = `${SERVER_URI}/payment/validate`;
  const ADD_VMTOHA = `${SERVER_URI}/user/add-vm-to-ha`;
  // useEffect(() => {
  //   // Load data only when the component mounts
  //   if (
  //     localStorage.getItem("accessToken") === "" ||
  //     localStorage.getItem("accessToken") === undefined
  //   ) {
  //     setMessage("User not logged in");
  //     setAppOpen(true);
  //     setTimeout(() => {
  //       window.location.href = "/login";
  //       setAppOpen(false);
  //     }, 100);
  //   }
  // });

  useEffect(() => {
    let token = localStorage.getItem("accessToken");
    if (token) {
      let config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      axios
        .get(GET_USER, config)
        .then((response) => {
          const { paymentDetails } = response.data;
          // if (!paymentDetails) {
          //   window.location.href = "/SelectPlan"; // Redirect to overview if payment is not paid or if payment details are missing
          // }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, []);

  const [paymentSuccess, setPaymentSuccess] = React.useState(false);

  // useEffect(() => {
  //   let token = localStorage.getItem("accessToken");
  //   let config = {
  //     headers: { Authorization: `Bearer ${token}` },
  //   };
  //   axios
  //     .get(PAYMENT_VALIDATE, config)
  //     .then((res) => {
  //       if (res.data.success === true) {
  //         setSnackbarOpen(true);
  //         setPaymentSuccess(true);
  //         setMessage(res.data.message);
  //         setMessageVariant("success");
  //         setTimeout(() => {
  //           setSnackbarOpen(false);
  //         }, 5000);
  //         console.log("Payment Successful");

  //         setTimeout(() => {
  //           axios
  //             .get(CREATE_VM, config)
  //             .then((response) => {
  //               console.log("Virtual Machine Created:", response.data);
  //               if (response.data.message) {
  //                 setMessage(response.data.message);
  //                 setMessageVariant("success");
  //                 setSnackbarOpen(true)
  //                 setTimeout(() => {
  //                   setSnackbarOpen(false);
  //                 }, 5000);
  //               } else if (response.data.warning) {
  //                 setMessage(response.data.warning);
  //                 setMessageVariant("warning");
  //               } else if (response.data.error) {
  //                 setMessage(response.data.error);
  //                 setMessageVariant("error");
  //               }
  //             })
  //             .catch((vmError) => {
  //               console.error("Error creating virtual machine:", vmError.response.data.message);
  //               //  setIsLoading(false);
  //         setSnackbarOpen(true);
  //         setMessage(vmError.response.data.error);
  //         setMessageVariant("error");
  //         setTimeout(()=>{
  //           setSnackbarOpen(false);
  //         },2000)
  //             })
  //             .finally(() => {
  //               // setSnackbarOpen(true);
  //               setTimeout(() => {
  //                 setSnackbarOpen(false);
  //               }, 5000);
  //             });
  //         }, 1000); // Adjust this delay as needed to ensure payment success message is displayed first
  //       } else {
  //         console.error("Payment validation failed");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error validating payment:", error);
  //       // setMessage("Payment validation failed")
  //       // setMessageVariant("error")
  //       // setSnackbarOpen(true)
  //     });
  // }, []);
  useEffect(() => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    axios
      .get(PAYMENT_VALIDATE, config)
      .then((res) => {
        if (res.data.success === true) {
          setSnackbarOpen(true);
          setPaymentSuccess(true);
          setMessage(res.data.message);
          setMessageVariant("success");
          setTimeout(() => {
            setSnackbarOpen(false);
          }, 5000);
          console.log("Payment Successful");
          ldapIntegration();
          mappingVmToDb();
          // setTimeout(() => {
          //   axios
          //     .get(CREATE_VM, config)
          //     .then((response) => {
          //       console.log("Virtual Machine Created:", response.data);
          //       if (response.data.message) {
          //         setMessage(response.data.message);
          //         setMessageVariant("success");
          //         setSnackbarOpen(true)
          //         setTimeout(() => {
          //           setSnackbarOpen(false);
          //         }, 5000);
          //       } else if (response.data.warning) {
          //         setMessage(response.data.warning);
          //         setMessageVariant("warning");
          //       } else if (response.data.error) {
          //         setMessage(response.data.error);
          //         setMessageVariant("error");
          //       }
          //     })
          //     .catch((vmError) => {
          //       console.error("Error creating virtual machine:", vmError.response.data.message);
          //       //  setIsLoading(false);
          // setSnackbarOpen(true);
          // setMessage(vmError.response.data.error);
          // setMessageVariant("error");
          // setTimeout(()=>{
          //   setSnackbarOpen(false);
          // },2000)
          // })
          // .finally(() => {
          //   // setSnackbarOpen(true);
          //   setTimeout(() => {
          //     setSnackbarOpen(false);
          //   }, 5000);
          // });
          // }, 1000); // Adjust this delay as needed to ensure payment success message is displayed first
        } else {
          console.error("Payment validation failed");
        }
      })
      .catch((error) => {
        console.error("Error validating payment:", error);
        // setMessage("Payment validation failed")
        // setMessageVariant("error")
        // setSnackbarOpen(true)
      });
  }, []);
  const handleSecondAPICall = () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    axios
      .get(ADD_VMTOHA, config)
      .then((response) => {
        // Handle response from the second API call
        console.log("Second API Call Response:", response.data);

        // Show response in snackbar
        setSnackbarOpen(true);
        setMessage(response.data.message); // Assuming the response contains a message
        setMessageVariant("success");
      })
      .catch((error) => {
        // Handle error from the second API call
        console.error("Error making second API call:", error);

        // Show error in snackbar
        setSnackbarOpen(true);
        setMessage("Error: " + error.message); // Set error message in snackbar
        setMessageVariant("error");
      });
  };
  return (
    <div>
      <TopBar />
      <Box sx={{ padding: "30px", backgroundColor: "#fff",marginLeft:"-18px" }}>
        <div style={{ display: "flex", justifyContent: "center",margin:"30px",width:"100%" }}>
          <Breadcrumb />
        </div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
            "@media (max-width: 600px)": {
              flexDirection: "column",
              justifyContent: "center",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "50px",
              backgroundColor: "#346CEA",
              borderRadius: "75px",
              width: "300px", // Adjust width as needed
              height: "300px",
              marginRight: "20px",
              position: "relative",
              "@media (max-width: 600px)": {
                display: "none",
              },
              
            }}
          >
            <Typography
              sx={{
                ...styles.typography,
                fontFamily: "Poppins",
                fontSize: "42px", // Adjusted font size for "Thank you"
                fontWeight: 600,
                lineHeight: "52px",
                letterSpacing: "0em",
                textAlign: "center",
                color: "#C7F760",
              }}
            >
              <div style={{ textTransform: "uppercase" }}>Thank you</div>
              <div
                style={{
                  color: "#fff",
                  fontSize: "24px",
                  textTransform: "uppercase",
                }}
              >
                for your order
              </div>
            </Typography>
            <img
              src={TermsConditionVector}
              alt=""
              style={{
                position: "absolute",
                right: "0",
                bottom: "0",
                zIndex: 0,
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "45px 26px",
              backgroundColor: "#346CEA",
              borderRadius: "30px",
              width:"79vw",
              display: "none",
              "@media (max-width: 600px)": {
                display: "block",
              },

            }}
          >
            <Typography
              sx={{
                ...styles.typography,
                fontFamily: "Sofia Sans Extra Condensed",
                fontSize: "38px", // Adjusted font size for "Thank you"
                fontWeight: 700,
                lineHeight: "100%",
                letterSpacing: "0em",
                textAlign: "center",
                color: "#C7F760",
              }}
            >
              <div style={{ textTransform: "uppercase" }}>Thank you</div>
              <div
                style={{
                  fontFamily:"Roboto Flex",
                  color: "#fff",
                  fontSize: "24px",
                  textTransform: "uppercase",
                  fontWeight:"400px"
                }}
              >
                for your order
              </div>
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: "7px" /* Adjusted margin to remove top margin */,
              padding: "50px",
              backgroundColor: "#fff",
              borderRadius: "75px",
              border: "2px solid #1E53E8",
              width: "100%",
              "@media (max-width: 600px)": {
                padding: "10px",
                borderRadius: "35px",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins",
                ...description.typography,
                fontSize: "18px",
                fontWeight: 500,
                lineHeight: "27px",
                letterSpacing: "0em",
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              Congratulations! You've successfully secured your access to the
              powerful MegaConnect Cloud PC. Get ready to unlock a world of
              learning possibilities without the burden of a physical machine.
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <Link to="/overview">
                <Button
                  sx={{
                    fontFamily: "Roboto Flex",
                    width: "100%",
                    textAlign: "center",
                    // marginTop: "30px",
                    backgroundColor: "#C7F760",
                    color: "#1E53E8",
                    textTransform:"capitalize", 
                    fontWeight: 900,
                    "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
                  }}
                  variant="contained"
                >
                  Go to Dashboard
                </Button>
              </Link>
            </div>
          </Box>
        </Box>
      </Box>
      <CustomSnackbar message={message} variant={variant} open={snackbaropen} />
    </div>
  );
}

export default Confirmation;
